let settingStorage = require('./storage.js');
const webEncrypt  = require('./webchatEncryptDecrypt.js');
let language = require("./locale/language.js");


let userToken;
module.exports = {
    getSettings: function () {
        let settingStorage = require('./storage.js');
        let settingUtils = require('./utils.js');

        let settingUrl = window._env_.ApiURL + "/users/config";
        $.ajax({
            url: settingUrl ,
            type: 'GET',
            dataType: 'json',
            cache: false,
            contentType: false,
            processData: false,
            async: false,
            crossDomain: true,
            headers: {
                'authorization': settingStorage.getuserToken()
            },
            statusCode: {
                401: function (response) {
                    console.log('Security Token Error');
                },
                500: function (response) {
                    console.log('Internal Server Error');
                }
            },
            success: function (response) {
                userToken = settingStorage.getuserToken();
                let loggedUser = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo')[0][0];
                let encryptKey = loggedUser.repeat(3);
                let decryptedResponse = JSON.parse(settingUtils.decrypt(response.data, encryptKey));
                webEncrypt.encryptAndStoreInLocalStorage('settings', decryptedResponse)
                
            },
            error: function (jqXHR, exception) {

                settingUtils.errorMsgHandling(jqXHR, exception)

            }
        });
        return true;
    },
    updateGroups: function () {
        let settingUtils = require('./utils.js');

        let groupsUrl = window._env_.ApiURL + "/users/addInPendingGroups";
        $.ajax({
            url: groupsUrl ,
            type: 'GET',
            dataType: 'json',
            cache: false,
            contentType: false,
            processData: false,
            async: false,
            crossDomain: true,
            headers: {
                'authorization': settingStorage.getuserToken()
            },
            statusCode: {
                401: function (response) {
                    console.log('Security Token Error');
                },
                500: function (response) {
                    console.log('Internal Server Error');
                }
            },
            success: function (response) {
                webEncrypt.deleteItemFromLocalStorage(language.locali().isPendingGroupParticipant)
            },
            error: function (jqXHR, exception) {

                settingUtils.errorMsgHandling(jqXHR, exception)

            }
        });
        return true;
    },
}